import React from "react";
import {MainCP}  from "../../Components/imacec-vs-percepcion/MainCP"

const Viewimacecper: React.FC = () => <MainCP/>

export default Viewimacecper;